import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { AdminUser } from '../models/admin.models';
import { ApiResponse, PaginatedResponse } from '../models/api-response.model';

@Injectable({
  providedIn: 'root'
})
export class AdminUsersService {
  private baseUrl = `${environment.apiBaseUrl}/admin/users`;

  constructor(private http: HttpClient) {}

  getUsers(): Observable<PaginatedResponse<AdminUser>> {
    return this.http.get<any>(this.baseUrl).pipe(
      map(res => res.data ?? res)
    );
  }

  getUser(id: number): Observable<AdminUser> {
    return this.http.get<ApiResponse<AdminUser>>(`${this.baseUrl}/${id}`).pipe(
      map(res => res.data)
    );
  }

  updateUser(id: number, data: Partial<AdminUser>): Observable<AdminUser> {
    return this.http.put<ApiResponse<AdminUser>>(`${this.baseUrl}/${id}`, data).pipe(
      map(res => res.data)
    );
  }

  blockUser(id: number): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/${id}/block`, {});
  }

  unblockUser(id: number): Observable<void> {
    return this.http.post<void>(`${this.baseUrl}/${id}/unblock`, {});
  }
}
